<section *ngIf="ageVerify!=true && ageVerify !='true' " class="home" [ngStyle]="{'background': 'url(' + bgImage + ') no-repeat 0 0 / cover'}">
    <div class="container">

        <div class="contents">
            <div class="get-verify" style="padding: 0;">
                <!-- <div *ngIf="!loader">
                    <div class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <p class="analyzing">We are analyzing...</p>
                </div> -->
                <div >
                    <img src="{{logoImage}}" style=" margin-bottom: 15px;">
                    <h5 style="color: #fff;">{{ageVerification}}?</h5>
                    <a href="javascript:;" *ngIf="pickUpStoreList?.length > 1" (click)="verifyAge(true)" class="get-verified">yes</a>
                    <a href="javascript:;" *ngIf="pickUpStoreList?.length  ==1" (click)="verifyAge(true);updatePickUpStoreData(pickUpStoreList[0]?.Id, pickUpStoreList[0]?.Name, pickUpStoreList[0]?.storeAccountNum, pickUpStoreList[0]?.authorization, pickUpStoreList[0].Address.AddressLine1, pickUpStoreList[0].Address.AddressLine2, pickUpStoreList[0].Address.City, pickUpStoreList[0].Address.StateName, pickUpStoreList[0].Address.StateCode, pickUpStoreList[0].Address.CountryName, pickUpStoreList[0].Address.CountryCode, pickUpStoreList[0].Address.Zip, pickUpStoreList[0]?.storeLocation, pickUpStoreList[0]?.location?.coordinates[0], pickUpStoreList[0]?.location?.coordinates[1],false,pickUpStoreList[0])" class="get-verified">yes</a>

                    <a (click)="verifyAge(false)" href="javascript:;" class="another-account">no</a>
                </div>
            </div>
        </div>
    </div>
</section>



<div class=" modal get-verify-number-popup" id="parkvillePopUp" data-backdrop="static" data-keyboard="false" style="background-size: 100%;background: url(bgImage) !important;">
    <div class="modal-dialog welcome-to-new-site">
        <div class="modal-content" style="background: transparent; box-shadow: none;">
            <div class="modal-body">
                <div class="get-verify">
                    <h2>We are not doing deliveries at this moment.</h2>
                    <h4>You can select Pickup or come visit us at our store</h4>
                    <img src="assets/images/sorry1.png">
                    <a href="javascript:;" *ngIf="pickUpStoreList?.length > 1" (click)="openModal(2)" class="select_store_1">SELECT A STORE NEAR YOU</a>
                    <a href="javascript:;" (click)="closeParkPop()" class="get-verified close">
                        <img src="assets/images/close1.png" alt="">
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Search Location FOR PICKUP Pop-->
<div class="modal search-location modalBackgroundNone firstpopuponload where-are-you Pick_Up_Store_new New_all_store_location_list" data-backdrop="static" data-keyboard="false" id="SearchLocation" [ngStyle]="{'background': 'url(' + bgImage + ') no-repeat 0 0 / cover'}">
    <div class="modal-dialog">
        <div class="modal-content" style='background: transparent!important;'>
            <div class="modal-body" style="padding: 0 !important;">

                <div class="Location_checkout">
                    <div class="Checkout_logo">
                        <img src="{{siteDada?.footerLogo?.url}}">
                        <h2>{{siteDada?.storePageTitle}}</h2>
                        <h3>{{siteDada?.storePageDescription}}</h3>
                    </div>
                    <div class="All-Location_List">
                        <div class="row justify-content-center">
                            <ng-container *ngFor=" let list of pickUpStoreList;let k=index">
                                <div class="col-md-4">
                                    <div class="Location_list">
                                        <h4>
                                            {{list?.Name}}
                                            <a (click)="popupOpen(list?.storeMobile,list?.Name, list?.Address?.City, list?.Address?.StateName,list?.Address?.CountryCode,list?.Address?.Zip,list)">
                                                <img src="assets/images/about-icon-23.png" width="20px">
                                            </a>
                                        </h4>
                                        <figure>
                                            <img class="location-store-img" src="{{list?.image}}" (click)="updatePickUpStoreData(list?.Id, list?.Name, list?.storeAccountNum, list?.authorization, list?.Address?.AddressLine1, list?.Address?.AddressLine2, list?.Address?.City, list?.Address?.StateName, list?.Address?.StateCode, list?.Address?.CountryName, list?.Address?.CountryCode, list?.Address?.Zip, list?.storeLocation, list?.location?.coordinates[0], list?.location?.coordinates[1],false,list)">
                                        </figure>
                                        <a (click)="updatePickUpStoreData(list?.Id, list?.Name, list?.storeAccountNum, list?.authorization, list?.Address?.AddressLine1, list?.Address?.AddressLine2, list?.Address?.City, list?.Address?.StateName, list?.Address?.StateCode, list?.Address?.CountryName, list?.Address?.CountryCode, list?.Address?.Zip, list?.storeLocation, list?.location?.coordinates[0], list?.location?.coordinates[1],false,list)" class="Site_product_list">
                                            menu
                                        </a>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal" tabindex="1" role="dialog" id="popup1information" data-keyboard="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="overlay1information">
                <div class="popup1information">
                    <a class="close cursor" (click)="popUpClose()">&times;</a>
                    <ng-container *ngFor=" let list of pickUpStoreList;let k=index">
                        <div class="content" *ngIf="list?.Name== selectedStoreName">
                            <p innerHtml="{{list?.storeInfo}}"></p>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Store Popup modal -->
<div class=" modal get-verify-number-popup mobilePopUp" id="storeHistoryModal" data-backdrop="static" data-keyboard="false" style="background: url(bgImage); background: rgba(0,0,0,0.8) !important;">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <div class="">
                    <div class="herader_location_popup">
                        <a *ngIf="pickUpStoreList?.length > 1" (click)="selectMailOrderFromHeader('true')" class="newButton" style="display: inline-block;">
                            Switch Location
                        </a>
                        <a style="margin: 10px 8px 0 0;" (click)="storeOpenCloseTimeing(selectedStoreName)" class="mobile_about_imfo">
                            <img src="assets/images/about-icon-23.png" width="24px"></a>
                        <img src="{{selectedStoreImage}}" alt="{{selectedStoreName}}" style="border-radius: 0px;margin-bottom: 15px; height: 200px;
                        width: 100%;">
                        <div>
                            <h2>{{selectedStoreName}}
                                <span class="store_open" *ngIf="!StoreClosed">Open</span>
                                <span class="store_close" *ngIf="StoreClosed">Closed</span>
                                <a style="cursor: pointer;margin-top: -3px;margin-left: 5px;float: right;" class="mobile_about_mobile" [href]="'tel:'+storeMobile"><i style="font-size: 24px;" class="fa fa-phone"></i></a>
                            </h2>
                        </div>
                        <p class="loc-adddress-home">
                            <a href="http://maps.google.com/?q={{selectedStoreAddress}}" target="_blank"> <img style="cursor:pointer;" src="assets/images/place.png" class="loca-img-new" alt="">{{selectedStoreAddress}}
                            </a>
                        </p>

                        <h4 style="display:flex; align-items: center;">
                            <span class="desktop-Visible">
                                Service Options
                                <a style="margin-left: 10px;" (click)="storeOpenCloseTimeing(selectedStoreName)" class="tablat_about_imfo">
                                    <img src="assets/images/about-icon-23.png" width="24px"></a>
                                <a class="tablat_about_mobile" [href]="'tel:'+storeMobile"><i style="font-size: 24px;" class="fa fa-phone"></i></a>
                            </span>
                        </h4>
                        <p style="font-size: 16px;line-height: 28px; " id="newIdgivenNow"> {{manageOrderOption('Delivery')}}{{manageOrderOption('Pickup')}}{{manageOrderOption('CurbsidePickup')}} <br>
                            <b style="font-size: 15px ;" class="stylePop">
                                <span *ngIf="manageStoreTIme('Pickup')">In-Store
                                    {{newStoreHoursFormat(this.pickopenHour?.Open?.Hour,this.pickopenHour?.Open?.Minute)}} -
                                    {{newStoreHoursFormat(this.pickopenHour?.Close?.Hour,this.pickopenHour?.Close?.Minute)}}</span>
                                <br>
                                <span *ngIf="manageStoreTIme('Delivery')"> Delivery
                                    {{newStoreHoursFormat(this.delOpenHour?.Open?.Hour,this.delOpenHour?.Open?.Minute)}} -
                                    {{newStoreHoursFormat(this.delOpenHour?.Close?.Hour,this.delOpenHour?.Close?.Minute)}}</span>
                            </b>
                        </p>


                        <a class="herader_location_popup_close" (click)="modalClose()"><i class="fa fa-close"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="modal mobilePopUp" id="storeOpenCloseTimeing" data-backdrop="static" data-keyboard="false" style="background: url(bgImage); background: rgba(0,0,0,0.8) !important;">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <div class=" newPara_dynamic">
                    <ng-container *ngFor="let list of pickUpStoreList">
                        <div *ngIf="list.Name == selectedStoreName">
                            <p innerHtml="{{list?.storeInfo}}"></p>
                            <a class="herader_location_popup_close" (click)="storeOpenCloseTimeing1()"><i class="fa fa-close"></i></a>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>